import LegalLayout, { LegalSection } from "./LegalLayout";
import { CONTROLLER, LEGAL } from "../../lib/legal";

export default function PrivacyPolicy() {
    return (
        <LegalLayout title="Privacy Policy" version={LEGAL.privacyVersion} testid="privacy-page">
            <LegalSection>
                <p>
                    La presente informativa è resa ai sensi degli artt. 13 e 14 del Regolamento (UE)
                    2016/679 (&ldquo;GDPR&rdquo;) e del D.Lgs. 196/2003 e descrive le modalità di
                    trattamento dei dati personali degli utenti della piattaforma{" "}
                    <strong>{CONTROLLER.product}</strong>.
                </p>
            </LegalSection>

            <LegalSection title="1. Titolare del trattamento">
                <p>
                    Titolare del trattamento è <strong>{CONTROLLER.legalName}</strong>, con sede in{" "}
                    {CONTROLLER.address} (P.IVA/C.F. {CONTROLLER.vat}, REA {CONTROLLER.rea}). Per
                    qualsiasi richiesta in materia di privacy è possibile scrivere a{" "}
                    <a className="underline" href={`mailto:${CONTROLLER.pec}`}>{CONTROLLER.pec}</a>.
                </p>
            </LegalSection>

            <LegalSection title="2. Categorie di dati trattati">
                <ul className="list-disc pl-5 space-y-1">
                    <li><strong>Dati di registrazione e account</strong>: nome e cognome, email, nome dell&apos;organizzazione, password (conservata in forma cifrata con hashing bcrypt).</li>
                    <li><strong>Dati di utilizzo</strong>: aree geografiche monitorate, ricerche, aste salvate, analisi generate, impostazioni.</li>
                    <li><strong>Dati tecnici</strong>: indirizzo IP, user-agent, log di accesso e di sicurezza, registrazioni dei consensi.</li>
                    <li><strong>Documenti caricati</strong>: perizie/avvisi e relativi contenuti che l&apos;utente decide volontariamente di caricare per l&apos;analisi.</li>
                </ul>
            </LegalSection>

            <LegalSection title="3. Dati di terzi contenuti nei documenti d'asta (art. 14 GDPR)">
                <p>
                    Le aste giudiziarie aggregate dalla piattaforma provengono da fonti pubbliche
                    (portali autorizzati alla pubblicità legale delle vendite giudiziarie). I documenti
                    pubblici associati (perizie, avvisi di vendita) possono incidentalmente contenere
                    dati personali di soggetti terzi (es. debitori esecutati, occupanti). Tali dati:
                </p>
                <ul className="list-disc pl-5 space-y-1">
                    <li>sono trattati <strong>esclusivamente</strong> per l&apos;elaborazione tecnica dell&apos;analisi richiesta dall&apos;utente (base giuridica: legittimo interesse, art. 6.1.f GDPR);</li>
                    <li><strong>non sono mai riportati</strong> negli output delle analisi: i modelli AI sono istruiti a riferirsi a tali soggetti solo in forma generica (es. &ldquo;il debitore&rdquo;), in conformità alle misure del Garante sulla pubblicità delle vendite giudiziarie;</li>
                    <li>non sono oggetto di diffusione, indicizzazione o vendita a terzi;</li>
                    <li>gli annunci relativi ad aste con data già trascorsa non restano pubblicati nel feed della piattaforma.</li>
                </ul>
                <p>
                    Gli interessati possono esercitare i propri diritti scrivendo a{" "}
                    <a className="underline" href={`mailto:${CONTROLLER.pec}`}>{CONTROLLER.pec}</a>.
                </p>
            </LegalSection>

            <LegalSection title="4. Finalità e basi giuridiche">
                <ul className="list-disc pl-5 space-y-1">
                    <li>Erogazione del servizio e gestione dell&apos;account — <em>esecuzione del contratto</em> (art. 6.1.b GDPR).</li>
                    <li>Adempimenti legali, fiscali e contabili — <em>obbligo legale</em> (art. 6.1.c).</li>
                    <li>Sicurezza della piattaforma, prevenzione abusi e frodi — <em>legittimo interesse</em> (art. 6.1.f).</li>
                    <li>Gestione dei consensi e riscontro all&apos;esercizio dei diritti — <em>obbligo legale</em>.</li>
                </ul>
                <p>
                    Il conferimento dei dati di registrazione è necessario per fruire del servizio: il
                    mancato conferimento impedisce la creazione dell&apos;account.
                </p>
            </LegalSection>

            <LegalSection title="5. Modalità del trattamento">
                <p>
                    I dati sono trattati con strumenti elettronici, adottando misure tecniche e
                    organizzative adeguate (cifratura delle password, cookie di sessione{" "}
                    <code>HttpOnly/Secure</code>, controllo degli accessi, protezione anti brute-force,
                    isolamento dei dati per organizzazione, log di sicurezza).
                </p>
            </LegalSection>

            <LegalSection title="6. Destinatari e responsabili del trattamento">
                <p>
                    I dati possono essere trattati da fornitori che agiscono come responsabili ex art. 28
                    GDPR, tra cui: fornitori di hosting/infrastruttura cloud e fornitori di servizi di
                    intelligenza artificiale utilizzati per l&apos;elaborazione delle analisi (es.
                    provider di modelli LLM). I documenti e i testi inviati per l&apos;analisi possono
                    essere trasmessi a tali provider al solo scopo di generare il risultato richiesto. I
                    dati non sono oggetto di diffusione né di vendita a terzi.
                </p>
            </LegalSection>

            <LegalSection title="7. Trasferimenti extra-UE">
                <p>
                    Qualora alcuni fornitori trattino dati al di fuori dello Spazio Economico Europeo, il
                    trasferimento avviene in presenza di garanzie adeguate ai sensi degli artt. 44 ss.
                    GDPR (es. Clausole Contrattuali Standard della Commissione Europea).
                </p>
            </LegalSection>

            <LegalSection title="8. Periodo di conservazione">
                <p>
                    I dati dell&apos;account sono conservati per la durata del rapporto e cancellati a
                    seguito della chiusura dell&apos;account, salvo i dati che debbano essere conservati
                    per adempiere a obblighi di legge (es. fiscali, fino a 10 anni) o per la difesa in
                    giudizio. A titolo indicativo:
                </p>
                <ul className="list-disc pl-5 space-y-1">
                    <li><strong>Dati account e contenuti</strong>: per la durata del servizio; cancellati alla chiusura dell&apos;account.</li>
                    <li><strong>Registrazioni dei consensi</strong>: per il tempo necessario a dimostrarne il rilascio e comunque non oltre i termini di prescrizione applicabili.</li>
                    <li><strong>Richieste di assistenza/diritti (modulo contatti)</strong>: fino a 24 mesi dalla chiusura della richiesta.</li>
                    <li><strong>Log di sicurezza, tentativi di accesso e audit trail</strong>: per un periodo limitato e proporzionato (orientativamente 12 mesi), per finalità di sicurezza e accountability.</li>
                </ul>
            </LegalSection>

            <LegalSection title="9. Diritti dell'interessato">
                <p>
                    L&apos;utente può esercitare in qualsiasi momento i diritti di cui agli artt. 15-22
                    GDPR: accesso, rettifica, cancellazione (&ldquo;diritto all&apos;oblio&rdquo;),
                    limitazione, portabilità, opposizione e revoca dei consensi. Dall&apos;area{" "}
                    <strong>Account</strong> è possibile <strong>esportare i propri dati</strong> e{" "}
                    <strong>cancellare l&apos;account</strong> in autonomia. Per ogni altra richiesta:{" "}
                    <a className="underline" href={`mailto:${CONTROLLER.pec}`}>{CONTROLLER.pec}</a>.
                </p>
            </LegalSection>

            <LegalSection title="10. Reclamo all'Autorità di controllo">
                <p>
                    L&apos;interessato ha diritto di proporre reclamo al Garante per la protezione dei
                    dati personali (www.garanteprivacy.it) qualora ritenga che il trattamento violi la
                    normativa applicabile.
                </p>
            </LegalSection>

            <LegalSection title="11. Modifiche">
                <p>
                    La presente informativa può essere aggiornata. La versione vigente è sempre
                    pubblicata su questa pagina con indicazione della data di aggiornamento e del numero
                    di versione.
                </p>
            </LegalSection>
        </LegalLayout>
    );
}
